import React, { Component } from "react";
// import dbAxios from "../configurations/axios";
import PROJECTS from "../utilities/projects";
const DataContext = React.createContext();

class DataProvider extends Component {
	state = {
		login: { show: false, status: false, username: "", password: "" },
		navigation: {
			data: [
				// { name: "Home", type: "section" },
				{ name: "Projects", type: "section" },
				{
					name: "Login",
					type: "button",
					clicked: async () => {
						if (this.state.login.status === true) {
							this.state.changeLoginStatus(false);
						} else {
							await this.state.toggleLoginPanel(true);
						}
					},
				},
			],
			active: "Home",
		},
		projects: null,
		toggleLoginPanel: async (booled) => {
			const updatedLogin = { ...this.state.login };
			updatedLogin.show = booled;
			await this.setState({ login: updatedLogin });
		},
		changeLoginStatus: async (booled) => {
			const updatedLogin = { ...this.state.login };
			const updateNavigation = { ...this.state.navigation };

			if (booled !== false) {
				updatedLogin.status = true;
				updatedLogin.data = {
					username: booled.data.name,
					email: booled.data.email,
					id: booled.data.id,
				};
				updateNavigation.data.forEach((element) => {
					if (element.name === "Login") {
						element.name = booled ? "Logout" : "Login";
					}
				});
			} else {
				updatedLogin.status = false;
				updatedLogin.data = null;
			}

			await this.setState({
				login: updatedLogin,
				navigation: updateNavigation,
			});
		},
		changeActiveNavElement: (item) => {
			this.setState({ navigation: { ...this.state.navigation, active: item } });
		},
		fetchAllProjects: async () => {
			this.setState({ projects: PROJECTS });
		},
	};

	render = () => {
		return (
			<DataContext.Provider value={this.state}>
				{this.props.children}
			</DataContext.Provider>
		);
	};
}

export { DataContext };

export default DataProvider;
